export const baseUrl = {
    development: process.env.DOMAIN_URL || 'http://badoo-after-dark.frontend.svc.kube.mlan:8080',
    test: process.env.DOMAIN_URL || 'http://badoo-after-dark.frontend.svc.kube.mlan:8080',
    production: process.env.DOMAIN_URL || 'https://badoo.com',
}[process.env.NODE_ENV];
